// class HearingAidPriceModel {
// 	String? id;
// 	String? title;
// 	String? type;
// 	String? price;
// 	String? first;
// }

import ModelCommon from "./ModelCommon";
import { defaultDB } from "utils/firebase";
import { collection, doc, getDoc, getDocs, setDoc, updateDoc, deleteDoc, where, 
    runTransaction, query, orderBy, limit as limitFn, Timestamp, serverTimestamp, FieldValue } 
    from "firebase/firestore";

class HearingAidPriceModel {
    constructor(json) {
        this.id = ModelCommon.toText(json.id, false);
        this.title = ModelCommon.toText(json.title, false);
        this.type = ModelCommon.toText(json.type, false);
        this.price = ModelCommon.toText(json.price, false);
        this.first = ModelCommon.toText(json.first, false);
    }

    static skeleton = () => {
        let model = {
            id: null,
            title: null,
            type: null,
            price: null,
            first: null,
        }
        return HearingAidPriceModel(model);
    }

    toJson = () => {
        return {
            id: this.id,
            title: this.title,
            type: this.type,
            price: this.price,
            first: this.first,
        };
    }

    toString = () => {
        return JSON.stringify(this.toJson());
    }
}

class HearingAidPriceDb {
    static collectionName = "hearingAidPrices";
  
    static currentTimestamp = () => serverTimestamp();
  
    static dateToTimestamp = (date) => Timestamp.fromDate(new Date(date));
  
    static timestampToDate = (timestamp) =>
      ModelCommon.toTimestamp(timestamp)?.toDate();
  
    static collectionRef = () => collection(defaultDB, this.collectionName);
  
    static docRef = (id) => doc(defaultDB, this.collectionName, id);
  
    static runTransaction = async (func) => {
      return await runTransaction(defaultDB, func);
    };
  
    static loadAll = async (limitCount) => {
      const itemList = [];
  
      const q = limitCount
        ? query(this.collectionRef(), orderBy("createAt", "desc"), limitFn(limitCount))
        : query(this.collectionRef(), orderBy("createAt", "desc"));
  
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((docSnap) => {
        const item = docSnap.data();
        item.id = docSnap.id;
        itemList.push(item);
      });
  
      return itemList;
    };
  
    static load = async (id) => {
      const docSnap = await getDoc(this.docRef(id));
      return docSnap.exists() ? docSnap.data() : null;
    };
  
    static add = async (model) => {
      const newDocRef = doc(this.collectionRef());
      const addModel = { ...model, id: newDocRef.id };
      await setDoc(newDocRef, addModel);
    };
  
    static update = async (id, model) => {
      await updateDoc(this.docRef(id), model);
    };
  
    static updateOrder = async (models) => {
      if (!models.length) return;
  
      await this.runTransaction(async (transaction) => {
        const firstRef = this.docRef(models[0].id);
        const firstSnap = await transaction.get(firstRef);
        if (!firstSnap.exists()) throw new Error("Document does not exist!");
  
        models.forEach((model) => {
          const ref = this.docRef(model.id);
          transaction.update(ref, { order: model.order });
        });
      });
    };
  
    static delete = async (id) => {
      await deleteDoc(this.docRef(id));
    };
  
    static set = async (id, model) => {
      await setDoc(this.docRef(id), model);
    };
  }

export { HearingAidPriceModel, HearingAidPriceDb };

// 1. 필드 추가
/*
const [title, setTitle] = React.useState(hearingAidPrice.title);
const [type, setType] = React.useState(hearingAidPrice.type);
const [price, setPrice] = React.useState(hearingAidPrice.price);
const [first, setFirst] = React.useState(hearingAidPrice.first);
*/

// 2. 값 입력 부분 구현
/*
if (title != undefined) {
    newItem.title = title;
}
if (type != undefined) {
    newItem.type = type;
}
if (price != undefined) {
    newItem.price = price;
}
if (first != undefined) {
    newItem.first = first;
}
*/
